import React, {Component} from 'react';
import Tabs from '../pages/Tabs';
import axios from 'axios';
import {Link} from 'react-router-dom';


export default class Firstapi extends Component {

  constructor(props) {
    super(props)

    this.state = {
      personal:[],
      business:[]
    }
  }

  componentDidMount(){
    axios.get("https://product-dot-is-uk-uat-integration-core.nw.r.appspot.com/v1/market/liverate",{
        method:'GET',
        headers:{
        'Username' : 'vipin',
        'Password':'vipin123#',
        'Authorization':'Basic dmlwaW46dmlwaW4xMjMj',
        'Accept':'application/json',
        'Content-Type':'application/json'
      }
     
    })
    .then(response => {
     
     this.setState({
      personal:response.data.personal,
      business:response.data.business
     })
    })
  }

    render(){
      const {personal} = this.state;
      const {business} = this.state;
       return (
       <div>
      <Tabs>
          <div className="col-sm-12" label="Personal">
               <ul className="header-title">
                    <li>Account Type</li>
                    <li>Standard</li>
                    <li>ISA</li>
                    {/* <li>View</li> */}
                  </ul> 


        {personal.length ===0 ? 
        (
          <div className="text-align-center">
            <img src={process.env.PUBLIC_URL + '/assets/sites/default/files/loader.gif'} alt="loader_img" className="img-fluid mt-5"/>
          </div>
        )  :
        personal.map((personal_post,i) => {
           return (
           <div>
            {  personal_post.items.length ===0 ? 
              (
                <ul className="tbldesign-list" key={personal_post.i}>
                <li>{personal_post.displayName == null ? 'None' : personal_post.displayName } 
                  {personal_post.note != null ? <Link to={'/'} className="tool-tip" data-title={personal_post.note}><i className="fas fa-info-circle"></i></Link> : ''}
                </li>
                <li>{personal_post.aer == null ? 'None' : personal_post.aer.toFixed(2)+'%' }</li>
                <li>{personal_post.isaAer == null ? 'None' : personal_post.isaAer.toFixed(2)+'%' }</li>
                {/* <li><Link to={`/fixed-rate-bond/${personal_post.rateCatId}`} className="tbldes-listbtn"><span>See More</span> <i className="far fa-eye"></i></Link></li> */}
                </ul>
              ):(
                <ul className="tbldesign-list tbldesign-list-full" key={personal_post.i}>
                  <li><p class="tbldesign-text-px">{personal_post.displayName}</p>
                {
                  personal_post.items.map((post_items,j) => {
                    return (
                      <ul className='tbldesign-sublist'>
                      <li>{post_items.displayName == null ? 'None' : post_items.displayName } 
                        {personal_post.note != null ? <Link to={'/'} className="tool-tip" data-title={personal_post.note}><i className="fas fa-info-circle"></i></Link> : ''}
                      </li>
                      <li>{post_items.aer == null ? 'None' : post_items.aer.toFixed(2)+'%' } </li>
                      <li>{post_items.isaAer == null ? 'None' : post_items.isaAer.toFixed(2)+'%' } </li>
                      {/* <li><a href="#" class="tbldes-listbtn"><span>See More</span> <i class="far fa-eye"></i></a></li> */}
                      </ul> 
                    )
                  })
                }
                </li>
                </ul>
              )
            }
           </div>
           )
        })}
        </div>
  
        <div className="col-sm-12" label="Business">
          <ul className="header-title">
            <li>Account Type</li>
            <li>Standard</li>
            <li>ISA</li>
            {/* <li>View</li> */}
          </ul> 
            {business.length ===0 ?  (
            <div className="text-align-center">
              <img src={process.env.PUBLIC_URL + '/assets/sites/default/files/loader.gif'} alt="loader_img" className="img-fluid mt-5"/>
            </div>
            ):
            business.map((business_post,i) => {
            return (
            <div>
              {  
                business_post.items.length ===0 ? 
                (
                  <ul className="tbldesign-list" key={business_post.i}>
                    <li>{business_post.displayName == null ? 'None' : business_post.displayName }  
                      {business_post.note != null ? <Link to={'/'} className="tool-tip" data-title={business_post.note}><i className="fas fa-info-circle"></i></Link> : ''}
                    </li>
                    <li>{business_post.aer == null ? 'None' : business_post.aer.toFixed(2)+'%' }</li>
                    <li>{business_post.isaAer == null ? 'None' : business_post.isaAer.toFixed(2)+'%' }</li>
                    {/* <li><Link to={'/fixed-rate-bond/' + business_post.rateCatId} className="tbldes-listbtn"><span>See More</span> <i className="far fa-eye"></i></Link></li> */}
                  </ul>
                ):(
                  <ul className="tbldesign-list tbldesign-list-full" key={business_post.i}>
                  <li><p class="tbldesign-text-px">{business_post.displayName == null ? 'None' : business_post.displayName }</p>
                  {
                  business_post.items.map((business_post_items,j) => {
                    return (
                      <ul className='tbldesign-sublist'>
                      <li>{business_post_items.displayName == null ? 'None' : business_post_items.displayName }
                        {business_post.note != null ? <Link to={'/'} className="tool-tip" data-title={business_post.note}><i className="fas fa-info-circle"></i></Link> : ''}
                      </li>
                      <li>{business_post_items.aer == null ? 'None' : business_post_items.aer.toFixed(2)+'%' } </li>
                      <li>{business_post_items.isaAer == null ? 'None' : business_post_items.isaAer.toFixed(2)+'%' } </li>
                      {/* <li><Link to={'/fixed-rate-bond/' + business_post.rateCatId} className="tbldes-listbtn"><span>See More</span> <i className="far fa-eye"></i></Link></li> */}
                      </ul> 
                    )
                  })
                  }
                  </li>
                  </ul>
                )
              }
            </div>
            )
          })}
        </div>
      </Tabs> 

 </div>
        )
    }
}